import type { Unsubscribe } from '@amazon/vinyl-util'
import { getAuthRecovery } from '@/service/gql'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('authRecoveryPrompt')

/** Opens the recovery modal for each auth rejection `gqlFetch` latches. */
export function installAuthRecoveryPrompt(): Unsubscribe {
    return getAuthRecovery().onData((kind) => {
        if (!kind) return
        import('@/messaging/systemModals')
            .then((modals) =>
                kind === 'profileUnavailable'
                    ? modals.openProfileUnavailableModal()
                    : modals.openSessionExpiredModal()
            )
            .catch(errorHandler)
    })
}
